import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ZoomIn, ZoomOut } from "lucide-react";

const CONFIDENCE_STYLES = {
  alta: "border-green-400 focus-within:border-green-500",
  media: "border-amber-400 focus-within:border-amber-500",
  baja: "border-red-400 focus-within:border-red-500",
};

const CONFIDENCE_LABELS = { alta: "Confianza alta", media: "Confianza media — revisar", baja: "Confianza baja o vacío — revisar" };

function _isEmptyValue(value) {
  if (value === null || value === undefined || value === "") return true;
  if (Array.isArray(value) && value.length === 0) return true;
  return false;
}

export function ConfidenceField({ confianza, value, children, testId }) {
  // Un campo vacío/null se pinta SIEMPRE en rojo, sin importar la confianza que declare el
  // modelo — de lo contrario {valor: null, confianza: "alta"} se muestra vacío en verde.
  const empty = _isEmptyValue(value);
  const c = empty ? "baja" : (confianza || "baja");
  const label = empty ? "Vacío — revisar" : CONFIDENCE_LABELS[c];
  return (
    <div className={`rounded-md border-2 p-1 transition-colors ${CONFIDENCE_STYLES[c]}`} title={label} data-testid={testId}>
      {children}
    </div>
  );
}

export function MatchScoreNote({ match, testId }) {
  if (!match) return null;
  const pct = match._score != null ? Math.round(match._score * 100) : null;
  return (
    <p className="mt-1 text-xs text-primary" data-testid={testId}>
      Sugerido: {match.codigo} — {match.razon_social}{pct != null ? ` (coincidencia ${pct}%)` : ""}
    </p>
  );
}

export function DocumentPreview({ docId, mimeType, testId }) {
  const [zoom, setZoom] = useState(1);
  const url = `${process.env.REACT_APP_BACKEND_URL}/api/documents/${docId}/file`;
  const isPdf = mimeType === "application/pdf";

  return (
    <div className="flex h-full flex-col rounded-md border border-border bg-slate-100" data-testid={testId}>
      {!isPdf && (
        <div className="flex items-center justify-end gap-1 border-b border-border bg-white p-1.5">
          <Button type="button" size="icon" variant="ghost" onClick={() => setZoom((z) => Math.max(0.5, z - 0.25))} data-testid={`${testId}-zoom-out`}>
            <ZoomOut className="h-4 w-4" />
          </Button>
          <span className="w-10 text-center text-xs text-muted-foreground">{Math.round(zoom * 100)}%</span>
          <Button type="button" size="icon" variant="ghost" onClick={() => setZoom((z) => Math.min(3, z + 0.25))} data-testid={`${testId}-zoom-in`}>
            <ZoomIn className="h-4 w-4" />
          </Button>
        </div>
      )}
      <div className="flex-1 overflow-auto">
        {isPdf ? (
          <iframe src={url} title="documento" className="h-full w-full border-0" style={{ minHeight: 500 }} />
        ) : (
          <div className="flex justify-center p-3">
            <img src={url} alt="documento" style={{ transform: `scale(${zoom})`, transformOrigin: "top center" }} className="max-w-full" />
          </div>
        )}
      </div>
    </div>
  );
}
